import React, { Component } from "react";

import ModalConditions from "../modal/modal_conditions";

class Conditions extends Component {
  state = { openModal: false };
  render() {
    if (!this.props.list.give_away) {
      return <div />;
    }
    if (this.props.list.give_away.conditions === "") {
      return <div />;
    }
    return (
      <React.Fragment>
        <label style={{ textTransform: "capitalize" }} className=" btn_skip">
          By pressing start you agree with the{" "}
          <span
            className="yaystack_color cursor_btn"
            onClick={this.openningModal}
          >
            terms and conditions
          </span>
        </label>
        <ModalConditions
          open={this.state.openModal}
          text={this.props.list.give_away.conditions}
          handleCloseView={this.handleCloseView}
        />
      </React.Fragment>
    );
  }

  openningModal = event => {
    event.preventDefault();
    this.setState({ openModal: true });
  };

  handleCloseView = e => {
    this.setState({ openModal: false });
  };
}

export default Conditions;



// WEBPACK FOOTER //
// ./src/components/list/interface/winner/conditions.jsx